/**
 * 支付中心弹窗
 * @returns
 */
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Flex,
  Box,
  Grid,
  GridItem,
  Center,
  Image,
  Icon,
  Input,
  Button,
  Avatar,
  Text,
  HStack,
  Progress,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Link,
  useToast
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { MemberCard, Recharge, Goods } from "@/types/integral";
import { useSelector, useDispatch } from "react-redux";
import { updateUser, selectUser } from "@/reducer/userslice";
import {
  useLazyGetMemberCardQuery,
  useLazyGetRechargeQuery,
  useCreateNativePayMutation,
  useLazyGetOrderStatusQuery,
} from "@/services/api/endpoints/integral";
import { ServerError } from "@/types/errors";
import * as math from 'mathjs';

import viplevel from "@/assets/viplevel.png";
import vipClass1 from "@/assets/images/integral_img5.png";
import vipClass2 from "@/assets/images/integral_img6.png";
import IntegralImg from "@/assets/images/integral_img3.png";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  tabIndex?: number;
};

let timer:any;
const PayCenterModal = (props: Props) => {
  const { isOpen, onClose, tabIndex } = props;
  const dispatch =  useDispatch();
  const user = useSelector(selectUser);
  const toast = useToast();
  const [showPay, setShowPay] = useState(false);
  const [payPrice, setPayPrice] = useState<number | null>(null);
  const [currentIndex, setCurrentIndex] = useState<number | null>(null);
  const [payType, setPayType] = useState<string>('微信');
  const [qrcode, setQrcode] = useState('');
  const [orderSn, setOrderSn] = useState('');

  const [getMemberCards, {data:memberCards}]  = useLazyGetMemberCardQuery();
  const [getRechargeCards, {data:rechargeCards}]  = useLazyGetRechargeQuery();
  // const { data:  memberCards } = useGetMemberCardQuery("0");
  // const { data:  rechargeCards } = useGetRechargeQuery("1");
  const [createNativePay] = useCreateNativePayMutation();
  const [getOrderStatus, {data:orderStatus}]  = useLazyGetOrderStatusQuery();
  // const {data: orderStatus} = useGetOrderStatusQuery(orderSn);

  useEffect(()=>{
    if(isOpen){
      if(tabIndex===0){
        getMemberCards("0");
      }
      if(tabIndex===1){
        getRechargeCards("1")
      }
    }
  },[tabIndex, isOpen])

  const handleChangeTab = (index: number)=>{
    setShowPay(false);
    setCurrentIndex(null);
    clearInterval(timer);
    if(index===0){
      getMemberCards("0");
    }
    if(index===1){
      getRechargeCards("1")
    }
  }

  
  const handleChangeMemberPay = async (member:MemberCard, index:number) => {
    clearInterval(timer);
    setCurrentIndex(index);
    console.log(member)
    // const total = member.current_price * 100;
    // const discountPrice = Number(member.original_price-member.current_price);
    // const discount = discountPrice * 100;
    const total = Number(math.multiply(math.bignumber(member.current_price), math.bignumber(100)));
    const discountPrice = Number(math.subtract(math.bignumber(member.original_price), math.bignumber(member.current_price)))
    const discount = Number(math.multiply(math.bignumber(discountPrice), math.bignumber(100)))
    const goods: Goods = {
      productId: member.id,
      total: total,
      count: member.total,
      productName: member.card_type,
      discount: discount,
      productType: "0",
      payway: payType,
      untilday: member.untilday,
      give: member.dailygive,
      givecount: member.givecount
  }
  console.log(goods,"goods1111")

  const result = await createNativePay(goods).unwrap().catch((e) => {
    toast({
      title: (e as ServerError).message,
      position: "top",
      status: "error",
      duration: 2000,
      isClosable: true,
    });
  });
  if(result){
    setQrcode(result.url);
    setOrderSn(result.order_sn)
    setShowPay(true);
    setPayPrice(member.current_price);
    // 轮询查看支付状态
    timer = setInterval(() => getOrderStatusFunc(), 1000);
  }
      
  };

  const handleChangeRechargePay = async (recharge:Recharge, index:number) => {
    clearInterval(timer);
    setCurrentIndex(index);

    // const total = recharge.amount * 100;
    // const count = recharge.amount * recharge.ratio;
    const total = Number(math.multiply(math.bignumber(recharge.amount), math.bignumber(100)));
    const count = Number(math.multiply(math.bignumber(recharge.amount), math.bignumber(recharge.ratio)));
    const goods: Goods = {
      productId: recharge.id,
      total: total,
      count: count,
      productName: recharge.charge_type,
      discount: 0,
      productType: "1",
      payway: payType,
      untilday: 0,
      give: 0,
      givecount: recharge.givecount
  }
  console.log(goods,"goods2222")

  const result = await createNativePay(goods).unwrap().catch((e) => {
    toast({
      title: (e as ServerError).message,
      position: "top",
      status: "error",
      duration: 2000,
      isClosable: true,
    });
  });
  if(result){
    setQrcode(result.url);
    setOrderSn(result.order_sn)
    setShowPay(true);
    setPayPrice(recharge.amount);
    // 轮询查看支付状态
    timer = setInterval(() => getOrderStatusFunc(), 1000);
  }
      
  };

  // 获取付款状态
  const getOrderStatusFunc = async () => {
    await getOrderStatus(orderSn);
    if (orderStatus?.pay_status) {
        clearInterval(timer);
        onClose();
    }
}

useEffect(() => {
  return () => {
    clearInterval(timer);
  };
}, []);

  return (
    <Modal size="6xl" isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        width="902px"
        background="linear-gradient(90deg, #8E94A9 0%, #27314D 100%)"
      >
        <ModalHeader>
          <Flex>
            <Avatar
              mr={"20px"}
              src={`/api/v4/users/${user.id}/image`}
              w={"40px"}
              h={"40px"}
            />
            <Box>
              <HStack>
                <Text
                  mr="10px"
                  fontSize={"14px"}
                  color="#fff"
                  fontWeight={"bold"}
                >
                  充值账户：{user.username ?? user.nickname }
                </Text>
                <Image src={viplevel} />
              </HStack>
              <Progress
                mt="7px"
                colorScheme="whiteAlpha"
                bg="#8E94A9"
                size="sm"
                h="4px"
                value={20}
              />
              {/* <Text
                mt="6px"
                fontSize={"10px"}
                color="#E0E0E0"
                fontWeight={"normal"}
              >
                距离下一个等级还差786积分
              </Text> */}
            </Box>
          </Flex>
        </ModalHeader>
        <ModalCloseButton color={"#fff"} />
        <ModalBody mb="1rem">
          <Tabs
            isFitted
            variant="enclosed"
            defaultIndex={tabIndex}
            onChange={handleChangeTab}
          >
            <TabList bg="linear-gradient(180deg, rgba(254, 249, 238, 0.1) 0%, rgba(255, 255, 255, 0.1) 25%)">
              <Tab
                color={"#CBD1DF"}
                fontSize={"18px"}
                fontWeight="bold"
                borderRadius={"0"}
                _selected={{
                  color: "#27314D",
                  bg: "#fff",
                  clipPath: "polygon(0 0, 90% 0, 100% 100%, 0 100%)",
                }}
                sx={{
                  transition: "clip-path 0.5s",
                  backfaceVisibility: "hidden",
                }}
              >
                购买会员
              </Tab>
              <Tab
                color={"#CBD1DF"}
                fontSize={"18px"}
                fontWeight="bold"
                borderRadius={"0"}
                _selected={{
                  color: "#27314D",
                  bg: "#fff",
                  clipPath: "polygon(10% 0, 100% 0, 100% 100%, 0 100%)",
                }}
                sx={{
                  transition: "clip-path 0.5s",
                  backfaceVisibility: "hidden",
                }}
              >
                充值积分
              </Tab>
            </TabList>
            <TabPanels bg="#ffffff">
              {/* 购买会员 */}
              <TabPanel>
                <Flex gap="20px">
                  {memberCards && memberCards.map((item, index) => {
                    return (
                      <Box
                        key={index}
                        w="190px"
                        overflow={"hidden"}
                        cursor="pointer"
                        bg={currentIndex===index ? "rgba(238, 241, 247, 0.5)" : "#FCFCFC"}
                        border={currentIndex===index ? "1px solid #496AE1" : "none"}
                        _hover={{
                          border: "1px solid #496AE1",
                          bg: "rgba(238, 241, 247, 0.5)",
                          boxShadow: "2px 2px 10px 0px rgba(73, 106, 225, 0.1)",
                          ".child-bg": {
                            bg: "#DCE0EB",
                          },
                        }}
                        onClick={() => handleChangeMemberPay(item, index)}
                      >
                        <Center mt="20px">
                          <Image
                            display={index < 2 ? "block" : "none"}
                            mr="6px"
                            src={vipClass1}
                          />
                          <Image
                            display={index > 1 ? "block" : "none"}
                            mr="6px"
                            src={vipClass2}
                          />
                          <Text
                            color={"#27314D"}
                            fontSize="12px"
                            fontWeight="500"
                          >
                            {item.card_type}
                          </Text>
                        </Center>
                        <Flex
                          mt="12px"
                          mb="14px"
                          justifyContent={"center"}
                          alignItems={"baseline"}
                        >
                          <Text
                            color={"#27314D"}
                            fontSize="24px"
                            fontWeight="400"
                          >
                            ￥
                          </Text>
                          <Text
                            color={"#27314D"}
                            fontSize="36px"
                            fontWeight="400"
                            fontFamily="Allerta"
                          >
                            {item.current_price}
                          </Text>
                          <Text
                            ml="10px"
                            color={"#B9B9B9"}
                            fontSize="14px"
                            fontWeight="350"
                            textDecoration={"line-through"}
                          >
                            {item.original_price}
                          </Text>
                        </Flex>
                        <Box
                          h="34px"
                          lineHeight={"34px"}
                          color={"#27314D"}
                          fontSize="12px"
                          fontWeight="bold"
                          textAlign={"center"}
                          className="child-bg"
                          background={currentIndex===index ? "#DCE0EB" : "rgba(238, 241, 247, 0.5)"}
                        >
                          {/* {item.card_detail1} */}
                          基础VIP权益
      
                        </Box>
                        <Box
                          h="34px"
                          lineHeight={"34px"}
                          color={"#27314D"}
                          fontSize="12px"
                          textAlign={"center"}
                        >
                          {/* {item.card_detail2} */}
                          每月高达15000点算力
      
                        </Box>
                        <Box
                          h="34px"
                          lineHeight={"34px"}
                          color={"#27314D"}
                          fontSize="12px"
                          textAlign={"center"}
                          className="child-bg"
                          background={currentIndex===index ? "#DCE0EB" : "rgba(238, 241, 247, 0.5)"}
                        >
                          {/* {item.card_detail3} */}
                          云端储存空间20G
      
                        </Box>
                        <Box
                          h="34px"
                          lineHeight={"34px"}
                          color={"#27314D"}
                          fontSize="12px"
                          textAlign={"center"}
                        >
                          {/* {item.card_detail4} */}
                          生图加速特权每月300次
      
                        </Box>
                        <Box
                          h="34px"
                          lineHeight={"34px"}
                          color={"#27314D"}
                          fontSize="12px"
                          textAlign={"center"}
                          className="child-bg"
                          background={currentIndex===index ? "#DCE0EB" : "rgba(238, 241, 247, 0.5)"}
                        >
                          {/* {item.card_detail5} */}
                          畅享vip专属模型
      
                        </Box>
                        <Box
                          h="34px"
                          lineHeight={"34px"}
                          color={"#27314D"}
                          fontSize="12px"
                          textAlign={"center"}
                        >
                          {/* {item.card_detail6} */}
                          生图高级功能
                        </Box>
                        <Box
                          h="34px"
                          lineHeight={"34px"}
                          color={"#27314D"}
                          fontSize="12px"
                          textAlign={"center"}
                          className="child-bg"
                          background={currentIndex===index ? "#DCE0EB" : "rgba(238, 241, 247, 0.5)"}
                        >
                          {/* {item.card_detail7} */}
                          无
                        </Box>
                      </Box>
                    );
                  })}
                </Flex>
              </TabPanel>

              {/* 充值积分 */}
              <TabPanel>
                <Flex gap="20px">
                  {rechargeCards && rechargeCards.map((item, index) => {
                    return (
                      <Box
                        key={index}
                        
                        w="190px"
                        h="358px"
                        overflow={"hidden"}
                        cursor="pointer"
                        bg={currentIndex===index ? "#F6F7FB" : "#FCFCFC"}
                        border={currentIndex===index ? "1px solid #496AE1" : "none"}
                        _hover={{
                          border: "1px solid #496AE1",
                          bg: "#F6F7FB",
                          boxShadow: "2px 2px 10px 0px rgba(73, 106, 225, 0.1)",
                        }}
                        onClick={() => handleChangeRechargePay (item, index)}
                      >
                        <Center mt="75px" color={"#27314D"} alignItems="center">
                          <Text fontSize={"12px"} fontWeight={500} mr="10px">
                            {item.detail}
                          </Text>
                          <Text fontSize={"24px"} fontWeight={500} mr="2px">
                            {/* 88 */}
                          </Text>
                          <Image src={IntegralImg} />
                        </Center>
                        <Flex
                          mt="31px"
                          justifyContent={"center"}
                          alignItems={"baseline"}
                        >
                          <Text
                            color={"#27314D"}
                            fontSize="24px"
                            fontWeight="400"
                          >
                            ￥
                          </Text>
                          <Text
                            color={"#27314D"}
                            fontSize="36px"
                            fontWeight="400"
                            fontFamily="Allerta"
                          >
                            {item.amount}
                          </Text>
                        </Flex>
                        <Box
                          mt="49px"
                          color={"#8E94A9"}
                          fontSize="12px"
                          textAlign={"center"}
                        >
                          {item.give_detail}
                        </Box>
                      </Box>
                    );
                  })}
                </Flex>
              </TabPanel>
            </TabPanels>
          </Tabs>

          {/* 支付二维码 */}
          <Box display={showPay ? "block" : "none"} bg="#fff">
            <Flex
              h="109px"
              pl="40px"
              alignItems={"center"}
              bg="rgba(238, 241, 247, 0.5)"
            >
              <Image mr="20px" boxSize={"75px"} src={'data:image/png;base64,' + qrcode} />
              {/* <img src={'data:image/png;base64,' + qrcode} style={{marginRight: "20px", width:"75px", height: "75px"}} /> */}
              <Box>
                <Flex alignItems={"baseline"}>
                  <Text color={"#3D3D3D"} fontSize="12px">
                    实付：
                  </Text>
                  <Text color={"#27314D"} fontSize="24px">
                    ￥
                  </Text>
                  <Text color={"#27314D"} fontSize="36px" fontFamily="Allerta">
                    {payPrice}
                  </Text>
                </Flex>
                <Link fontSize={"12px"} color="#3D3D3D">
                  扫码支付 ｜ 支付同意《会员服务协议》 《会员详细规则》
                  会员服务群&gt;&gt;
                </Link>
              </Box>
            </Flex>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default PayCenterModal;
